/**
 * Auth Landing Screen
 * 
 * Initial authentication screen matching native app experience.
 * 
 * Features:
 * - Sign In (for existing users)
 * - Create Account (for new users) - hidden by default per desktop spec
 * 
 * Account creation is controlled by REACT_APP_ENABLE_ACCOUNT_CREATION env var.
 * Desktop version spec requires "sign-in only" (no account creation).
 * 
 * @module components/auth/AuthLandingScreen
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@sequelae/lore-core';
import './AuthLandingScreen.css';

// Account creation is disabled by default per desktop spec (Section 8: Reduced Functionality)
const ENABLE_ACCOUNT_CREATION = process.env.REACT_APP_ENABLE_ACCOUNT_CREATION === 'true';

export const AuthLandingScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    console.log('[AuthLanding] Sign in clicked');
    navigate('/sign-in');
  };

  const handleCreateAccount = () => {
    console.log('[AuthLanding] Create account clicked');
    navigate('/account-creation');
  };

  return (
    <div className="auth-landing-container">
      <div className="auth-landing-content">
        {/* Lore Logo */}
        <div className="auth-landing-logo">
          <img
            src="/logos/lore-wordmark-horizontal-color.png"
            alt="Lore"
            className="logo-wordmark"
          />
        </div>

        {/* Action Buttons */}
        <div className="auth-landing-actions">
          <Button
            variant="primary"
            size="large"
            fullWidth
            onClick={handleSignIn}
          >
            Sign In
          </Button>

          {/* Account creation hidden by default per desktop spec */}
          {ENABLE_ACCOUNT_CREATION && (
            <>
              <div className="auth-landing-divider">
                <span>or</span>
              </div>

              <Button
                variant="secondary"
                size="large"
                fullWidth
                onClick={handleCreateAccount}
              >
                Create Account
              </Button>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="auth-landing-footer">
          <p>By continuing, you agree to our</p>
          <div className="footer-links">
            <a href="https://www.lore.co/terms" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>
            <span>|</span>
            <a href="https://www.lore.co/privacypolicy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
